import React from 'react'
import { NavLink } from 'react-router'

const Footer = () => {
  return (
    <>
      <div className='mainhrdiv'>

        <div className='hrdiv'>
          <img className='logowhite' src="/images/logowhite.png" alt="logo" />
          <div className='vertical-line'></div>

          <div className='conttdiv'>

            <div className='eee'>
              <h1>Contact Information</h1>

              <div className='ee'>
                <img className='mobileviewimgs1' src="/images/loc.png" alt="location" />
                <p>Roop Sweets House, Near Bus Stand Bhucho Mandi 151101 <br /> Bathinda, Punjab</p>
              </div>

              <div className='ee'>
                <img className='mobileviewimgs1' src="/images/phn.png" alt="location" />
                <a title='make-call' href="tel:+919464119840">Roop Sweets - Nirmal</a>
              </div>

              <div className='ee'>
                <img className='mobileviewimgs1' src="/images/phn.png" alt="location" />
                <a title='make-call' href="tel:+919988756318">Roop Sweets - Sukhpal</a>
              </div>
              
              <div className='ee'>
                <img className='mobileviewimgs1' src="/images/mail1.png" alt="location" />
                <a title='write-mail' href="mailto:sukhi.singh79@yahoo.com">Roopsweets</a>
              </div>

              <div className='ee'>
                <img className='mobileviewimgs1' src="/images/mail1.png" alt="location" />
                <a title='write-mail' href="mailto:deepraman31104@gmail.com">Roopsweets</a>
              </div>

            </div>

            <div className='eee'>
              <h1>Follow Us</h1>

              <div className='socialM-imgsDivFooter'>
                <NavLink title='Instagram' target='_blank' to="https://www.instagram.com/roopsweets/?utm_source=qr&igsh=amdkYnV6bmZlZHBj"><img className='socialM-imgs1' src="images/instaW1.webp" alt="" /></NavLink>
                <NavLink id='facebook' title='Facebook' target='_blank' to="https://www.facebook.com/share/15Y5MX3Fyi/?mibextid=wwXIfr"><img className='socialM-imgs1' src="images/facebookW.png" alt="facebook img" /></NavLink>
                <NavLink title='WhatsApp'
                  target='_blank'
                  to="https://wa.me/9988756318?text=Hello%20Roop%20Sweets">
                  <img className='socialM-imgs1' src="images/whatsappW.png" alt="WhatsApp" />
                </NavLink>
              </div>

            </div>
          </div>

        </div>

        <p className='copyright'> <span><img className='crlogo' src="/images/crlogo.png" alt="" /></span> Copyright 2025, Roop Sweets. All Rights Reserved.</p>
        
          <hr className="hrnavbar nomargin" />
      </div>



    </>
  )
}

export default Footer
